import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputCheckboxMaster,
  InputOptionMaster,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState, useEffect } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  titleModal,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_LOKET_ANTRIAN = {
  id: "",
  code: "",
  name: "",
  remark: "",
  display_id: "",
  status: 1,
};

export const urlGet = LIST_URL_MASTER.tipe_antrian.list;
export const urlAdd = LIST_URL_MASTER.tipe_antrian.add;
export const urlUpdate = LIST_URL_MASTER.tipe_antrian.update;
export const urlDelete = LIST_URL_MASTER.tipe_antrian.delete;

const useDisplay = () => {
  const [state, setState] = useState([]);

  const fetchData = async () => {
    try {
      const res = await instance2.get(
        LIST_URL_MASTER.tipe_antrian.display_jenis_id,
        {
          headers: {
            jenis_id: "1",
          },
        }
      );

      return {
        state: true,
        data: res.data.body,
      };
    } catch (error) {
      return {
        state: false,
        message: "",
      };
    }
  };
  useEffect(() => {
    (async () => {
      const res = await fetchData();

      if (res.state) {
        const data = [
          {
            value: "",
            label: "Pilih",
          },
        ];
        res.data.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, []);

  return state;
};

// /ant_display/listant_display_jenisid
export const deleteLoketAntrianById = async (id) => {
  try {
    await instance2.post(
      urlDelete,
      {},
      {
        headers: {
          idantriantype: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "PREFIX",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "display_id",
    disablePadding: false,
    label: "DISPLAY ID",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "JENIS KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const add = async () => {
    return instance2.post(urlAdd, {
      ...formData,
    });
  };

  const display = useDisplay();

  const update = () => {
    return instance2.post(
      urlUpdate,
      {
        ...formData,
      },
      {
        headers: {
          idantriantype: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.judul === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await add();
          defaultToastSuccess("Berhasil menambah data");
        } else if (formData.id !== "") {
          await update();
          defaultToastSuccess("Berhasil mengubah data");
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_LOKET_ANTRIAN);
        setShowModal(false);
        setNewData();
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Loket Antrian Kunjungan`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='code'
              label='PREFIX (Jenis Antrian)'
              id='code'
              value={formData.code}
              onChange={handleChange("code")}
              placeholder='Jenis Antrian'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='JENIS ANTRIAN'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Jenis Antrian'
            />
          </Grid>
          <Grid item sm={12}>
            <InputOptionMaster
              name='display_id'
              label='PILIH DISPLAY'
              id='display_id'
              withSearch={false}
              data={display}
              value={formData.display_id}
              onChange={handleChange("display_id")}
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Keterangan'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Keterangan'
            />
          </Grid>
          <Grid item sm={12}>
            <InputCheckboxMaster
              checked={formData.status}
              name='status'
              id='status'
              label='Aktif'
              onChange={() =>
                setFormData({ ...formData, status: !formData.status })
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
